import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// import Vue from 'vue'
// const $t = Vue.prototype.$t
export var tabPaneArr = [{
  name: 'payroll_wage_15',
  title: 'step1',
  comp: function comp() {
    return import('./step1.vue');
  },
  data: {
    info: {}
  },
  id: 1 // 考勤设置
}, {
  name: 'payroll_wage_17',
  title: 'step2',
  comp: function comp() {
    return import('./step2');
  },
  data: {
    info: {},
    state: '' // 当前子项目状态
  },

  id: 2 // 工资设置
}, {
  name: 'payroll_wage_18',
  title: 'step2',
  comp: function comp() {
    return import('./step3');
  },
  data: {
    info: {},
    state: '' // 当前子项目状态
  },

  id: 3 // 工资设置
}];

export var tabData = {
  info: {},
  state: '',
  // 当前子项目状态
  is_self_task: '' // 是否本人操作
};